import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import './Header.scss';
import Configuration from '../../common/Configuration.json';

const Header = (props) => {
  const loggedOutLinks = (
    <div className="header-action-group">
      <div className="header-action">
        <Link className="header-action-link" to="/login">
          <div className="header-login-icon autotest-header-login-icon" />
          <div className="header-action-text">Login</div>
        </Link>
      </div>
    </div>
  );

  const loggedInLinks = (
    <div className="header-action-group">
      <div className="header-action">
        <Link className="header-action-link" to="/dashboard">
          <div className="header-dashboard-icon autotest-header-dashboard-icon" />
          <div className="header-action-text">Dashboard</div>
        </Link>
      </div>
      <div className="header-action">
        <Link className="header-action-link" to="/logout">
          <div className="header-logout-icon autotest-header-logout-icon" />
          <div className="header-action-text">Logout</div>
        </Link>
      </div>
    </div>
  );

  return (
    <header className="header">
      <div className="header-background" />
      <div className="header-content">
        <div className="header-logo autotest-header-logo">
          <Link className="header-logo-link hide-text" href={Configuration.homeUrl}>Skinny</Link>
        </div>
        {props.loggedIn ? loggedInLinks : loggedOutLinks}
      </div>
    </header>
  );
};

Header.propTypes = {
  loggedIn: PropTypes.bool
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.js
 **/